import React, { useEffect, useState } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import "../../styles/Attendance.scss";
import * as HeaderData from "../HeaderAuthentication";
import { baseURL } from "../BaseUrl";

function AttendanceBreakUps(props) {
  let meetingID = props.meetingID;
  const [attendanceBreakUpData, setAttendanceBreakUpData] = useState([]);

  useEffect(() => {
    if (meetingID) {
      getAttendanceBreakups();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.meetingID]);

  const getAttendanceBreakups = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: HeaderData.postTravelizeAuth,
    };
    fetch(
      `${baseURL}/api/Attendance/GetAttendanceBreakup?AttendanceID=${meetingID}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setAttendanceBreakUpData(res.result);
        } else {
          setAttendanceBreakUpData([]);
        }
      })
      .catch((error) => {
        console.log("ERROR", error);
      });
  };

  return (
    <div>
      {props.showModal && (
        <div className="modal-backdrop-attendance">
          <div className="modal-right-fade">
            <Modal.Dialog className="right-fade-modal-dialog">
              {attendanceBreakUpData && (
                <div>
                  <Modal.Header closeButton onHide={props.handleCloseModal}>
                    <Modal.Title className="hv-center attendance_beakup modal-heading">
                      ATTENDANCE BREAKEUP ({props.userName} - {props.attenDate})
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {attendanceBreakUpData &&
                      attendanceBreakUpData.map((data, i) => (
                        <Row className="details-row" key={i}>
                          <Col md={6}>
                            <div>
                              <span>
                                <span>
                                  {" "}
                                  <strong>Check-In Time :</strong>
                                </span>
                                &nbsp;
                                <strong className="color-green">
                                  {data?.checkInTime ?? "NA"}
                                </strong>
                              </span>
                            </div>
                            <div>
                              <span>
                                <span className="color-yellow">
                                  <i className="bi bi-geo-alt" />
                                </span>
                                &nbsp;
                                <span>{data?.checkInLocation ?? "NA"}</span>
                              </span>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div>
                              <span>
                                <span>
                                  {" "}
                                  <strong>Check-Out Time :</strong>
                                </span>
                                &nbsp;
                                <strong className="color-green">
                                  {data?.checkOutTime ?? "NA"}
                                </strong>
                              </span>
                            </div>
                            <div>
                              <span>
                                <span className="color-yellow">
                                  <i className="bi bi-geo-alt" />
                                </span>
                                &nbsp;
                                <span>{data?.checkOutLocation ?? "NA"}</span>
                              </span>
                            </div>
                          </Col>
                        </Row>
                      ))}
                  </Modal.Body>
                </div>
              )}
            </Modal.Dialog>
          </div>
        </div>
      )}
    </div>
  );
}

export default AttendanceBreakUps;
